import { useState } from "react";
import Gallery from "./gallery";
import useShop from "./use_shop";
import EditItem from "./edit_item";

function Shop() {
  const shop = useShop();
  const [editItem, setEditItem] = useState(null);
  const handleNewItem = () => {
    setEditItem({
      item_name: "",
      item_description: "",
      item_price: 0,
      item_group_id: -1,
      enable_status: 0,
      images: [],
    });
  };
  return (
    <div className="">
      <div className="flex justify-between items-center text-xl font-semibold m-4 w-100 p-2 rounded-md shadow-md">
        <div className="">Shop Items</div>
        <div className="me-4 flex items-center gap-2">
          <div className="flex rounded-md bg-white outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600">
            <input
              id="search"
              name="search"
              type="text"
              value={shop.searchString}
              onChange={(e) => shop.setSearchString(e.target.value)}
              placeholder="Search"
              className="block min-w-0 grow px-3 py-1.5 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"
            />
            <div className="flex py-1.5 pr-1.5">
              <kbd className="inline-flex items-center rounded border border-gray-200 px-1 font-sans text-xs text-gray-400">
                ⌘K
              </kbd>
            </div>
          </div>
          <button
            onClick={handleNewItem}
            className="rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Add
          </button>
        </div>
      </div>
      {shop.state.map((group) => (
        <div key={group.group_key} className="p-2">
          <div className="text-xl font-semibold w-100 p-4 border rounded-t-lg shadow-lg">
            {group.group_name} ({group.group_key})
          </div>
          <div className="">
            <Gallery items={group.items} setEditItem={setEditItem} />
          </div>
        </div>
      ))}
      <EditItem
        isOpen={editItem !== null}
        close={() => setEditItem(null)}
        item={editItem}
        groups={shop.groups}
      />
    </div>
  );
}
export default Shop;
